import { render, staticRenderFns } from "./BackendLayout.vue?vue&type=template&id=0972389a&"
import script from "./BackendLayout.vue?vue&type=script&lang=js&"
export * from "./BackendLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports